import types from '../../actions.types';

const { ROUTE_DETAILS } = types.routeDetails;

export default (data) => {

  return dispatch => {
    dispatch({
      type: ROUTE_DETAILS,
      data
    });
  }
}

